import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Card, Button, Input, Icon, Image } from 'semantic-ui-react';

const LoginForm = ({
  onSubmit,
  onChange,
  errors,
  successMessage,
  user,
  toggleAuthenticateStatus
}) => (
  <Card className="login-container">
    <Card.Content>

      <form>

        {successMessage && <p className="success-message">{successMessage}</p>}
        {errors.summary && <p className="error-message">{errors.summary}</p>}

        <div className="field-line w-100">
          <Input
            label="Email"
            floatingLabelText="Email"
            name="email"
            errorText={errors.email}
            onChange={onChange}
            value={user.email}
          />
        </div>

        <div className="field-line w-100">
          <Input
            label="Password"
            floatingLabelText="Password"
            type="password"
            name="password"
            onChange={onChange}
            errorText={errors.password}
            value={user.password}
          />
        </div>
          <Button primary onClick={onSubmit} className="mt-20">Log In</Button>


      </form>
    </Card.Content>
  </Card>
);

LoginForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  successMessage: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired
};

export default LoginForm;

//before form begin
 <Card.Header>Login</Card.Header>


//before form end
//<Card.Content extra>
//  Don't have an account? <Link to={'/signup'}>Create one</Link>.
//</Card.Content>



// WEBPACK FOOTER //
// ./src/components/LoginForm.js